/** Reads duration and dimensions from a local video File.
 *  Returns `null` when the browser cannot decode the file.
 *  The caller owns `blobUrl` and must revoke it when done. */
export const getLocalVideoMetadata = (
  file: File,
): Promise<{ blobUrl: string; duration: number; height: number; width: number } | null> => {
  return new Promise((resolve) => {
    let objectUrl: string;
    try {
      objectUrl = URL.createObjectURL(file);
    } catch {
      resolve(null);
      return;
    }

    const video = document.createElement('video');
    video.preload = 'metadata';
    video.muted = true;

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl);
      video.onloadedmetadata = null;
      video.onerror = null;
      video.removeAttribute('src');
      video.load();
    };

    video.onloadedmetadata = () => {
      const { duration, videoHeight, videoWidth } = video;
      video.onloadedmetadata = null;
      video.onerror = null;
      video.removeAttribute('src');
      video.load();

      if (!Number.isFinite(duration) || duration <= 0 || videoWidth <= 0 || videoHeight <= 0) {
        URL.revokeObjectURL(objectUrl);
        resolve(null);
        return;
      }

      resolve({ blobUrl: objectUrl, duration, height: videoHeight, width: videoWidth });
    };

    video.onerror = () => {
      cleanup();
      resolve(null);
    };

    video.src = objectUrl;
  });
};
